import React, { useEffect } from "react";
import { Navigate, useLocation } from 'react-router-dom';
import { useAppCommands } from '../appCore/AppRuntimeReact';

const SignUp: React.FC = () => {
  const { requestSignup } = useAppCommands();
  
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const signUpEmail = params.get('signUpEmail');

  useEffect(() => {
    
    if(!signUpEmail)
        return;

    void requestSignup({
      loginHint: signUpEmail,
      returnTo: `${window.location.origin}/dashboard`,
      redirectUri: `${window.location.origin}/dashboard`,
    });
  }, [requestSignup, signUpEmail]);

  if (!signUpEmail) {
    return <Navigate replace to="/getsignedup" />;
  }

  return <></>;
};


export default SignUp;
